<template>
  <div>
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title>
        <router-link class="text-decoration--none" :to="{ name: 'news' }">
          News & Updates
        </router-link>
        <v-icon> {{ icons.arrow }} </v-icon>
        <span>Create</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <div class="ma-4">
      <news-form ref="form" @save="saveNews" save-text="Create news" />
    </div>
    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { mdiChevronRight } from '@mdi/js'
import NewsForm from '@/components/BlogForm'
import { each } from 'lodash'
import * as BlogType from '@/utils/consts/BlogType'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'CreateNews',

  components: {
    NewsForm,
    AppBarNavIcon
  },

  data() {
    return {
      icons: {
        arrow: mdiChevronRight
      },
      loading: false,
      form: {
        title: '',
        subtitle: '',
        content: '',
        cover: null
      }
    }
  },

  methods: {
    saveNews(form) {
      const formData = new FormData()
      formData.append('type', BlogType.NEWS)
      each(form, (value, key) => {
        if (value !== null) {
          formData.append(key, value)
        }
      })
      this.$api
        .post('/blogs', formData)
        .then(response => {
          this.$toast('News successfully created!', {
            color: 'green'
          })
          this.$router.replace({ name: 'news' })
        })
        .catch(({ response }) => {
          if (response.data && response.data.errors) {
            this.$refs.form.setErrors(response.data.errors)
          }
        })
        .then(() => {
          this.$refs.form.setLoading(false)
        })
    }
  }
}
</script>
